import { Base } from '@studiometa/js-toolkit';
import { Frame, Menu, Panel, Action, Accordion, DataModel, DataEffect } from '@studiometa/ui';
import Sticky from './Sticky.js';

/**
 * Facets component
 */
export default class Facets extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Facets',
    refs: ['directinput'],
    components: {
      Frame,
      Action,
      Menu,
      Panel,
      PanelAccordion: Accordion,
      DataModel,
      DataEffect,
      Sticky,
    },
  };

  /**
   * form
   * @returns {HTMLFormElement}
   */
  get form() {
    return this.$el.querySelector('form');
  }

  /**
   * onDirectinputChange
   */
  onDirectinputChange() {
    const event = new Event('submit', { bubbles: true, cancelable: false });
    this.form.dispatchEvent(event);
  }
}
